import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import React from "react";
import { PieChartDataType } from "../../../types/charts";
import { PieChartWrapper } from "./ChartComponents";

const PieChart = ({ data }: { data: PieChartDataType }) => {
  const chartConfig: Highcharts.Options = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      animation: false,
    },
    title: {
      text: null,
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
      },
    },
    series: [
      {
        name: "Material Types",
        animation: false,
        colorByPoint: true,
        type: "pie",
        data: data.map((pieData) => {
          return {
            name: pieData.name,
            y: pieData.y,
          };
        }),
      },
    ],
  };
  return (
    <PieChartWrapper>
      <HighchartsReact highcharts={Highcharts} options={chartConfig} />
    </PieChartWrapper>
  );
};

export default PieChart;
